import ModalWrapper from '../../common/Modal/ModalWrapper';

const FractionalInvestmentModal = ({ modalType = 'Investment Journey' }) => {
    let image = '';

    if (modalType === 'Investment Journey') {
        image = require('../../../../images/fractional/investment/investment.png');
    } else if (modalType === 'Growth Journey') {
        image = require('../../../../images/fractional/investment/growth.png');
    } else if (modalType === 'Exit Journey') {
        image = require('../../../../images/fractional/investment/exit.png');
    }
    return (
        <ModalWrapper modalType="fractionalInvestment" modalCardClasses="maw90 bg38" customStyle={{ padding: '4rem 0px' }}>
            <img src={image} alt="Pricing Journey" className='w100' />
        </ModalWrapper>
    );
};

export default FractionalInvestmentModal;
